export const images = [
  {
     src: "assets/Other Photos/0c78c08338c66cd01993e5e264e5a2906ba00de6.png",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/7c554d51-7895-48ac-98c1-972f246eee21.jpg",
     width: 777,
     height: 1600,
  },
  {
     src: "assets/Other Photos/GPTempDownload-1.jpg",
     width: 4000,
     height: 3000,
  },
  {
     src: "assets/Other Photos/GPTempDownload-2.jpg",
     width: 4000,
     height: 3000,
  },
  {
     src: "assets/Other Photos/GPTempDownload-3.jpg",
     width: 4000,
     height: 3000,
  },
  {
     src: "assets/Other Photos/GPTempDownload.jpg",
     width: 4000,
     height: 3000,
  },
  {
     src: "assets/Other Photos/IMG_0020.jpeg",
     width: 5032,
     height: 6024,
  },
  {
     src: "assets/Other Photos/IMG_0201.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_0281.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_0289.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_0346.JPEG",
     width: 2046,
     height: 1536,
  },
  {
     src: "assets/Other Photos/IMG_0587.JPEG",
     width: 750,
     height: 741,
  },
  {
     src: "assets/Other Photos/IMG_0798.JPEG",
     width: 2048,
     height: 1536,
  },
  {
     src: "assets/Other Photos/IMG_0822.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_0899.JPG",
     width: 3024,
     height: 4032,
  },
  {
     src: "assets/Other Photos/IMG_0919.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_0949.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_0955.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_0969.JPG",
     width: 3024,
     height: 3780,
  },
  {
     src: "assets/Other Photos/IMG_1156.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_1515-1.JPG",
     width: 3024,
     height: 3778,
  },
  {
     src: "assets/Other Photos/IMG_1515.JPG",
     width: 1148,
     height: 2122,
  },
  {
     src: "assets/Other Photos/IMG_1524.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_1554.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_1563.PNG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_1564.JPG",
     width: 1080,
     height: 1920,
  },
  {
     src: "assets/Other Photos/IMG_1581.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_1583.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_1933.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_1998.JPEG",
     width: 3024,
     height: 4032,
  },
  {
     src: "assets/Other Photos/IMG_2343.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_2460.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_2515.JPG",
     width: 1080,
     height: 1352,
  },
  {
     src: "assets/Other Photos/IMG_2548.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_3428.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_3433.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_3442.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_3452.JPEG",
     width: 1536,
     height: 2046,
  },
  {
     src: "assets/Other Photos/IMG_3472.JPEG",
     width: 2048,
     height: 1536,
  },
  {
     src: "assets/Other Photos/IMG_3582.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_3583.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_3585.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_3644.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_3646.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_3650.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_4994.JPG",
     width: 828,
     height: 1104,
  },
  {
     src: "assets/Other Photos/IMG_5456.JPEG",
     width: 3024,
     height: 4032,
  },
  {
     src: "assets/Other Photos/IMG_5930.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_6147.JPEG",
     width: 2048,
     height: 1536,
  },
  {
     src: "assets/Other Photos/IMG_6257.JPEG",
     width: 2046,
     height: 1536,
  },
  {
     src: "assets/Other Photos/IMG_6292.JPEG",
     width: 2048,
     height: 1536,
  },
  {
     src: "assets/Other Photos/IMG_6670.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_6675.JPEG",
     width: 2048,
     height: 1536,
  },
  {
     src: "assets/Other Photos/IMG_6690.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_6830.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_6841.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_7402.JPEG",
     width: 1170,
     height: 1458,
  },
  {
     src: "assets/Other Photos/IMG_7405.JPEG",
     width: 1170,
     height: 1552,
  },
  {
     src: "assets/Other Photos/IMG_7433.JPG",
     width: 4000,
     height: 3000,
  },
  {
     src: "assets/Other Photos/IMG_7913.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_7957.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_7988.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_8072.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_8460.JPEG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_8461.JPEG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_8466.JPG",
     width: 2576,
     height: 1932,
  },
  {
     src: "assets/Other Photos/IMG_8469.JPEG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_8648.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_8919.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_8948.JPG",
     width: 3024,
     height: 4032,
  },
  {
     src: "assets/Other Photos/IMG_9162.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_9341.jpg",
     width: 3024,
     height: 4032,
  },
  {
     src: "assets/Other Photos/IMG_9406.JPG",
     width: 750,
     height: 1334,
  },
  {
     src: "assets/Other Photos/IMG_9410.JPEG",
     width: 1536,
     height: 2046,
  },
  {
     src: "assets/Other Photos/IMG_9744.JPEG",
     width: 1536,
     height: 2048,
  },
  {
     src: "assets/Other Photos/IMG_9963.JPG",
     width: 3024,
     height: 4032,
  },
];